import React from 'react'
import Header from "../components/Header/Header"
import Footer from "../components/Footer/Footer"
import PropertyCard from '../components/PropertyCard/PropertyCard'
import PropertyFilter from '../components/PropertyFilter/PropertyFilter'
import PropertyNoResult from "../components/PropertyNoResult/PropertyNoResult"
import qs from "qs"
import { Button, Form, Container, Row, Col, Fade } from "react-bootstrap";
import algoliasearch from "algoliasearch/lite"
import { SaveItem, savedSearchParams, UserObjectStoreProvider } from "@starberry/myaccount-website-utils"

// 
import {
  connectStats,
  SortBy,
  connectInfiniteHits,
  InstantSearch,
  RefinementList,
  connectSearchBox,
  connectMenu,
  connectRange,
  Configure,
  ToggleRefinement,
  connectSortBy,
  connectAutoComplete,
  ClearRefinements,
  connectToggleRefinement
} from "react-instantsearch-dom"
import Cookies from 'universal-cookie'
import { navigate } from "@reach/router"
import { Link } from "gatsby"
import Select from "react-select"
import SeoResults, { ACTION_TYPES, ACTION_DESC_TYPES, getPriceStr } from "../components/property-search/seoResults"
import { parseSearchUrl, propertyH1, propertyDesc } from "../components/property-search/utils";
import {resiSalesPropertyType, resiLettingsPropertyType, priceminRangeResiSale, pricemaxRangeResiSale, priceminRangeResiRent, pricemaxRangeResiRent, bedroomsRange} from "../components/common/propertyUtils";
// 

// 
const mycookies = new Cookies();
const updateAfter = 500
const DEBOUNCE_TIME = 500;

var minpriceval = minpriceval || ""
var maxpriceval = maxpriceval || ""

var includeSold = false;
var includeLet = false;
const searchClient = algoliasearch(
   process.env.GATSBY_ALGOLIA_APP_ID,
   process.env.GATSBY_ALGOLIA_SEARCH_API_KEY
)
const index_name = `${process.env.GATSBY_ALGOLIA_INDEX_NAME}`
// 

// Property results loop
const InfiniteHits = ({hits,hasPrevious,refinePrevious,hasMore,refineNext,location, userObjects}) => {

  return(
  <>
      {(hits.length > 0 && hasPrevious) && (
          <button
          id="myprevbut"
          onClick={refinePrevious}
          disabled={!hasPrevious}
          className="d-none property_show_more_btn"
          >
              Show prev
          </button>
      )}

      {
          hits.map((hit, i) => {

              // property details url structure
              let uriStr = "";
              let mysale = "";
              let stattstxt = ""
              if (hit.searchType === "sales" && (hit.department === 'residential') || (hit.department === 'new_developments') ) {
                uriStr = `property-for-sale/`
                mysale = `myResSaleProp`
                stattstxt=`for sale`
              } else if (hit.searchType === "lettings" && hit.department === 'residential') {
                uriStr = `property-to-rent/`
                mysale = `myResRentProp`
                stattstxt=`to rent`
              }
              // property details url structure
              //console.log('qqqqqqqqqqq', hit.objectID, hit)
              return(
                  <>
                    <PropertyCard 
                        price={"£"+hit.price.toLocaleString()}
                        priceQualifier={hit.price_qualifier}
                        propertyid={hit.objectID}
                        location={hit.display_address}
                        description={hit.description}
                        bedroomsCount={hit.bedroom}
                        bathroomsCount={hit.bathroom}
                        receptionsCount={hit.reception}
                        propertyVideo={hit.virtual_tour}
                        propertyImages={hit.images}
                        propertyDetailsLink={`/${uriStr}${hit.slug}-${hit.objectID}/`}
                        propertySearchType={hit.searchType}
                        status = {hit.status}
                        title ={hit.title}
                        userObjects={userObjects}
                        savedSearchParams={savedSearchParams}
                    />                   
                  </>
              )
          })
      }
  
      {(hits.length > 0 && hasMore) && (
        <div className="d-flex align-items-center justify-content-center contact-form">
          <div className="form__actions m-0">
            <button className="d-flex btn btn-white-outline " 
              id="mynextbut"
              onClick={refineNext}
              disabled={!hasMore}
            >
              <div>Load More</div><i className="icon-arrow-right"></i>
            </button>
          </div>                  
        </div>
      )}    

  </>
  )
}
const CustomInfiniteHits = connectInfiniteHits(InfiniteHits)
// Property results loop

// Searchbox
const SearchBox = connectSearchBox(({ currentRefinement, refine }) => {
  return (
      <div className="filter-search-input-box">
          <div className="dropdown">
              <i className="icon-location-input"></i>
              <Form.Control type="search" placeholder="Street, area or postcode" id="formBasicEmail" 
                onChange={event => refine(event.currentTarget.value.replace(/ /g, "-").toLowerCase())}
                value={currentRefinement.replace(/-/g, ' ')}
              />
          </div>
      </div>
  )
})
// Searchbox

// Property type
const buildingSelectbox = ({ items, currentRefinement, refine, department, type }) => {
  var propertyListDropdown = resiSalesPropertyType;
  if (department === "residential" && type === "lettings") {
    propertyListDropdown = resiLettingsPropertyType;
  }

  return (
    <Select
      name="building"
      options={propertyListDropdown}
      // value={{ value: 0, label: "All" }}
      placeholder="Property Type"
      onChange={(e) => { refine(e.value, e.label) }}
      isSearchable={false}
    />
  )
}

const CustombuildingSelectbox = connectMenu(buildingSelectbox)
// Property type

// Property Bedrooms
const bedroomSelectBox = ({
  currentRefinement,
  min,
  max,
  precision,
  refine,
}) => {

  let bedroomvalselect = ""
  if (currentRefinement.max !== undefined) {
    // bedroomvalselect = 0
    bedroomvalselect = currentRefinement.max
  } else if (currentRefinement.min !== undefined) {
    bedroomvalselect = currentRefinement.min
  }

  return (
    <Select
      name="bedroom"
      options={bedroomsRange}
      // value={{ value: "", label: "Any" }}
      placeholder="Bedrooms"
      onChange={(e) => {
        if (e.value === "") {
          refine(e.value)
        } else if (e.value === "0") {
          refine({
            max: e.value,
          })
        } else {
          refine({
            min: e.value,
          })
        }
      }}
      isSearchable={false}
    />
  )
}

const CustombedroomSelectbox = connectRange(bedroomSelectBox)
// Property Bedrooms 

// Min Price
const minpriceSelectbox = ({
  currentRefinement,
  min,
  max,
  precision,
  refine,
  type
}) => {
  var minPriceRange = priceminRangeResiSale;
  if (type === "lettings") {
    minPriceRange = priceminRangeResiRent;
  }
  if (currentRefinement.max !== undefined && currentRefinement.max != "0") {
    minPriceRange = minPriceRange.filter((x) => parseInt(x.value) < parseInt(currentRefinement.max))
  }

  minpriceval = currentRefinement.min
  return (
    <Select
      name="minprice"
      options={minPriceRange}
      isSearchable={false}
      placeholder="Min Price"
      onChange={(e) => {
        minpriceval = e.value
        if (e.value === "0") {
          if (maxpriceval !== "0") {
            refine({
              max: maxpriceval,
            })
          } else refine(e.value, e.label)
        } else {
          refine({
            min: e.value,
            max: maxpriceval,
          })
        }
      }}
    />
  )
}

const CustomminpriceSelectbox = connectRange(minpriceSelectbox)
// Min Price

// Max Price
const maxpriceSelectbox = ({
  currentRefinement,
  min,
  max,
  precision,
  refine,
  type
}) => {
  var maxPriceRange = pricemaxRangeResiSale;
  if (type === "lettings") {
    maxPriceRange = pricemaxRangeResiRent;
  }
  let maxpricedisable = ''
  if (currentRefinement.min !== undefined) {
    maxPriceRange = maxPriceRange.filter((x) => x.value == "0" || parseInt(x.value) > parseInt(currentRefinement.min))
  }
  if (currentRefinement.min == "400000") {
    maxpricedisable = 'disabled'
  }
  maxpriceval = currentRefinement.max
  return (
    <Select
      name="maxprice"
      options={maxPriceRange}
      defaultValue={{ value: "0", label: "Max Price" }}
      placeholder="Max Price"
      classNamePrefix={"select-opt"}
      isSearchable={false}
      onChange={(e) => {
        maxpriceval = e.value
        if (e.value === "0") {
          if (minpriceval) {
            refine({
              min: minpriceval,
            })
          } else refine(e.value, e.label)
        } else {
          refine({
            min: minpriceval,
            max: e.value,
          })
        }
      }}
    />
  )
}

const CustommaxpriceSelectbox = connectRange(maxpriceSelectbox)
// Max Price

// Sort by
const sortbyStyle = {
  control: base => ({
    ...base,
    boxShadow: "none",
    border: "none",
  }),
}

const CustomSortBy = ({ items, refine, currentRefinement }) => (
  <div className="property-filter__action sort">
      <span className="property-filter__label">Sort: </span>
      <Select
          isSearchable={false}
          styles={sortbyStyle}
          options={items}
          classNamePrefix={"custom-select"}
          className={"custom-select"}
          defaultValue={currentRefinement || ''}
          onChange={(e) => { refine(e.value, e.label) }}
          placeholder={
              <div className="custom-select__placeholder"> {"Most Recent"}</div>
          }
      />
  </div>
);

const CustomSortByFilter = connectSortBy(CustomSortBy);
// Sort by

// Include sold and let
const ToggletttRefinement = ({
  currentRefinement,
  label,
  count,
  refine,
  createURL,
  includeSoldLet,
}) => {

  var include_sold = currentRefinement;
  return (
    label === "Include Sold" ? (
    <a
      href={'javascript:;'}
      onClick={event => {
        event.preventDefault();
        includeSold = !includeSold;
        refine(!currentRefinement);
      }}
    >
      <div className="property-filter__action">
          <input type="checkbox" id="sold" name="sold" checked={includeSold ? "checked" : ""} />
          <label htmlFor="sold" className="property-filter__label">{label}</label>
      </div>
    </a>
    ) : (
      <a
      href={'javascript:;'}
      onClick={event => {
        event.preventDefault();
        includeLet = !includeLet;
        refine(!currentRefinement);
      }}
      >
      <div className="property-filter__action">
          <input type="checkbox" id="sold" name="sold" checked={includeLet ? "checked" : ""} />
          <label htmlFor="sold" className="property-filter__label">{label}</label>
      </div>
      </a>
    )

    
  )
}
  
const CustomToggleRefinement = connectToggleRefinement(ToggletttRefinement);
// Include sold and let

// No Results
const NoStats = ({ processingTimeMS, nbHits, location, status, department, OpenMember}) => {
return (
  <>
    {nbHits === 0 &&
      <>
        <div className="shell">
          <Row className="property-filter__row">
            <Col lg={12} className="no-properties-text mb-5">
              <h2 className="mb-0">Unfortunately, we do not currently have any properties that match your search criteria.</h2>
            </Col>
          </Row>
          <PropertyNoResult uriStr={location} status={status} department={department} OpenMember={OpenMember}/>
        </div>
      </>
    }
  </>
)
}

const CustomNoStats = connectStats(NoStats)
// No Results

// Results count
const Stats = ({ processingTimeMS, nbHits }) => <>{nbHits}</>

const CustomStats = connectStats(Stats)
// Results count

// Create URL
export const createURL = (props, state, location) => {
  let myarea = state.menu

  const isDefaultRoute =
    !state.query &&
    !state.SortBy &&
    state.page === 1 &&
    state.menu &&
    state.range &&
    !state.range.price &&
    !state.range.bedroom

  if (isDefaultRoute) {
    return ""
  }

  var areaPath = "in-london/"
  var bedroomPath = ""
  var pricePath = ""
  var pagePath = ""
  var propertypath = ""
  var sortPath = ""

  if (state.query) {
    if (state.query) {
      areaPath = "in-" + encodeURIComponent(decodeURIComponent(state.query)) + "/"
    }
  }

  const queryParameters = {}
  // Property path
  if (state.menu) {
    if (myarea["building"]) {
      propertypath = "type-" + myarea["building"] + "/"
    }
  }
  // Property path

  // Bedrooms & Price range path
  if (state.range) {
    // Bedrooms
    if (state.range.hasOwnProperty('bedroom') && parseInt(state.range.bedroom.max) == 0) {
      bedroomPath = "studio/" //queryParameters.price_max = state.range.price.max;
    }
    if (state.range.bedroom) {
      if (state.range.bedroom.min) {
        bedroomPath = state.range.bedroom.min + "-and-more-bedrooms/" //queryParameters.price_max = state.range.price.max;
      }
    }

    // Price
    if (state.range.price) {
      if (state.range.price.min && state.range.price.max) {
        pricePath = "between-" + state.range.price.min + "-and-" + state.range.price.max + '/' //queryParameters.price_min = state.range.price.min;
      } else if (state.range.price.max) {
        pricePath = "under-" + state.range.price.max + '/' //queryParameters.price_max = state.range.price.max;
      } else if (state.range.price.min) {
        pricePath = "over-" + state.range.price.min + '/' //queryParameters.price_max = state.range.price.max;
      }
    }
  }
  // Bedrooms & Price range path

  // Sort path
  if (state.sortBy) {
    if (state.sortBy === index_name + "_price_asc") {
      sortPath = "sortby-price-asc/";
    }
    if (state.sortBy === index_name) {
      sortPath = "";
    }
    if (state.sortBy === index_name + "_most_recent") {
      sortPath = "sortby-most-recent/";
    }
  }
  // Sort path

  // Page path
  if (state.page && state.page !== 1) {
    pagePath = `page-${state.page}/`
  }
  // Page path

  const queryString = qs.stringify(queryParameters, {
    addQueryPrefix: true,
    arrayFormat: "repeat",
  })

  let myUrl = `${areaPath}${propertypath}${bedroomPath}${pricePath}${queryString}${pagePath}${sortPath}`

  if ("/" === myUrl.substr(myUrl.length - 1))
    myUrl = myUrl.substr(0, myUrl.length - 1)

  return `${location}${myUrl}`

  
}
// Create URL

// URL to searchstate
const searchStateToUrl = (props, searchState, location) =>
  searchState ? `${createURL(props, searchState, location)}` : ""

const urlToSearchState = location => {

  if (location) {
    var query = ""
    let pathUri_main = ''

    let a1 = location.pathname.indexOf("/property/for-sale") > -1
    let a2 = location.pathname.indexOf("/property/to-rent") > -1

    if (a1 == true) {
      pathUri_main = location.pathname.split("/property/for-sale")
    } else if (a2 == true) {
      pathUri_main = location.pathname.split("/property/to-rent")
    } else {
      pathUri_main = location.pathname.split(location)
    }

    var areaVal = ""
    var bedVal = 10
    var minpriceVal = ""
    var maxpriceVal = ""
    var pageVal = ""
    var propertyval = ""
    var sortVal = ""
    var sortVal_filt = ""

    if (pathUri_main[1]) {
      // following could be regexp
      let pathUri = pathUri_main[1].split("/")

      //lets loop
      for (let vi = 1; vi <= pathUri.length; vi++) {
        // check for area
        if (typeof pathUri[vi] === "undefined") {
          continue
        }

        // Property type
        if (pathUri[vi].indexOf("type-") >= 0) {
          propertyval = pathUri[vi].replace("type-", "")
        }

        // Area
        if (pathUri[vi].indexOf("in-") >= 0) {
          areaVal = pathUri[vi].replace("in-", "")
        }

        // Price
        if (
          pathUri[vi].indexOf("between-") >= 0 ||
          pathUri[vi].indexOf("over-") >= 0 ||
          pathUri[vi].indexOf("under-") >= 0
        ) {
          let priceFilt1 = pathUri[vi].split("over-")
          if (priceFilt1[1]) {
            minpriceVal = priceFilt1[1]
          }
          let priceFilt2 = pathUri[vi].split("under-")
          if (priceFilt2[1]) {
            maxpriceVal = priceFilt2[1]
          }
          let priceFilt3 = pathUri[vi].split("between-")
          if (priceFilt3[1]) {
            let priceFilt4 = priceFilt3[1].split("-and-")
            minpriceVal = priceFilt4[0]
            maxpriceVal = priceFilt4[1]
          }
        }

        // Bedrooms
        if (pathUri[vi].indexOf("-and-more-") >= 0) {
          bedVal = pathUri[vi].replace("-and-more-bedrooms", "")
          // sortVal = index_name+"_bedrooms"
        }

        if (pathUri[vi].indexOf("studio") >= 0) {
          // its studio bedroom
          bedVal = 0
        }

        // Sort by
        if (pathUri[vi].indexOf("sortby-") >= 0) {
          sortVal_filt = pathUri[vi].replace("sortby-", "")

          if (sortVal_filt === "price-asc") {
            sortVal = index_name + "_price_asc"
          }

          if (sortVal_filt === "price-desc") {
            sortVal = index_name + "_price_desc"
          }

          if (sortVal_filt === "most-recent") {
              sortVal = index_name + "_most_recent"
          }
        }

        // Page
        if (pathUri[vi].indexOf("page") >= 0) {
          pageVal = pathUri[vi].replace("page-", "")
        }
      }
    }
  }

  // Property type
  if (propertyval) {
    query += `&menu[building]=` + propertyval
  }

  // Area
  if (areaVal) {
    areaVal = areaVal.toLowerCase();
    if(areaVal.length < 4) {
      areaVal = '"'+areaVal+'"'
    }
    if (areaVal == "london") query += `&query=`
    else query += `&query=` + areaVal
  }

  // Price
  if (minpriceVal) {
    query += `&range[price][min]=` + minpriceVal
  }

  if (maxpriceVal) {
    query += `&range[price][max]=` + maxpriceVal
  }

  // Bedrooms
  if (bedVal == 0) {
    query += `&range[bedroom][min]=` + 0
    query += `&range[bedroom][max]=` + 0
  } else if (bedVal < 10) {
    query += `&range[bedroom][min]=` + bedVal
  }

  // Page
  if (pageVal) {
    query += `&page=${pageVal}`
  }

  // Sort by
  if (sortVal) {
    query += `&sortBy=` + sortVal
  }

  return qs.parse(query)
}
// URL to searchstate
class SearchResultsTemplate extends React.Component {
    
  constructor(props) {
        super(props);
    }

    // 
    state = {
        searchState: urlToSearchState(typeof window !== 'undefined' ? window.location : ''),
        userObjects: [],
        mapview: false,
        isOpen: false,
        popupType: "",
        membDet:""
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location !== this.props.location) {
            this.setState({ searchState: urlToSearchState(this.props.location) })
        }
    }

    onSearchStateChange = searchState => {
        clearTimeout(this.debouncedSetState)
        this.debouncedSetState = setTimeout(() => {
            navigate(searchStateToUrl(this.props, searchState, this.props.locationname), searchState)
        }, updateAfter)
        this.setState({ searchState })
    }
    // 

    // Map view
    mapView = (e) => {
      navigate(this.props.location.pathname.replace("property", "property-map"))
    }
    // Map View

    render () {

        // Capitalize
        const capitalize = (s) => {
            if (typeof s !== 'string') return ''
            return s.charAt(0).toUpperCase() + s.slice(1)
        }
        // Capitalize

        const searchParams = parseSearchUrl(this.props.ptype, this.props.fullpathname, this.props.pcategorytype);

        const saveSearchParams = savedSearchParams(searchParams);
        if (searchParams.areas == "") {
          searchParams.areas = "london";
        }

        const h1 = propertyH1(searchParams, this.props.pcategorytype);
        
        const h1desc = propertyDesc(searchParams);

        const areaName =  decodeURIComponent(searchParams.areas);
  
        const pType = searchParams.pType;

        let propertyType = "";
        if (searchParams.type == "") {
          propertyType = "properties "
        } else {
          propertyType = searchParams.type
        }
    
        const actionStr = ACTION_TYPES[pType];

        var description = `Explore our latest collection of ${capitalize(propertyType)} ${actionStr} ${searchParams.areas}. Contact Sandfords estate agents in ${searchParams.areas} to find the right property for you.`

        const isPageLoadBg = (typeof this.props.fullpathname === "undefined");
        var split_sort_by = this.props.location.pathname.split('sortby-');
        var sort_by = split_sort_by.length > 1 ? split_sort_by[1] : '';
        var replaceH1 = h1.replace(/-/g, ' ');
        //replaceH1 = replaceH1.replace("Essex", "Essex and Kent");
        var replaceh1SEC = h1desc.replace(/-/g, ' ');
        //replaceh1SEC = replaceh1SEC.replace("Essex", "Essex and Kent");
        var areaReplace = capitalize(areaName).replace("%20"," ")
        //areaReplace = areaReplace.replace("Essex", "Essex and Kent");

        var defaultStatus = ["For Sale", "Sold Subject to Contract"]
            if (this.props.ptype === "lettings") {
              defaultStatus = ["To Rent"]
            }

            let mystatus = ''
            if(defaultStatus){
              if(Array.isArray(defaultStatus)){
                mystatus = '(status:"'+(defaultStatus).join('" OR status:"')+'")'
              } else {
                mystatus = '(status:"'+(defaultStatus)+'")'
              }
            }

  return (
    <>
    <Header/>
      <div className='search-results'>
      <SeoResults title={h1} searchParams={searchParams} description={description} location={this.props.fullpathname} pcategorytype={this.props.pcategorytype} />
        <InstantSearch
                    indexName={index_name}
                    searchClient={searchClient}
                    searchState={this.state.searchState}
                    onSearchStateChange={this.onSearchStateChange}
                    createURL={createURL}
                    routing="true"
                >
                    {/* <div className="d-none">
                        <RefinementList
                            attribute="searchType"
                            defaultRefinement={[this.props.ptype]}
                        />
                        <RefinementList
                            attribute="department"
                            defaultRefinement={[this.props.pcategorytype]}
                        />
                        <RefinementList
                            attribute="status"
                            defaultRefinement={this.props.pstatustype}
                        />
                        <RefinementList
                            attribute="publish"
                            defaultRefinement={[true]}
                        />
                    </div> */}
    
                    <Configure filters={`publish:true AND searchType:${this.props.ptype} AND department:${this.props.pcategorytype} AND ${mystatus}`}
                        hitsPerPage={12}
                    />
                            <Container>

          <div className='property-head'>
            <div className='property-count'>Displaying <CustomStats /> properties
              <div className="divider"></div>
              

              <div className="save-search">
                <UserObjectStoreProvider>
                <SaveItem type="search" searchParams={saveSearchParams} userObjects={this.props.userObjects}>
                  <span className="show-search"><i className="icon-heart"></i> Save Search</span>
                  <span className="remove-search"><i className="icon-heart-fill "></i> Remove Search</span>
                </SaveItem>
                </UserObjectStoreProvider>
              </div>
            </div>
            <h1>{replaceH1}</h1>
            <p className="result-intro">Discover a wide range of {replaceh1SEC} with Sandfords estate agents. To filter these results, use our filter below, or for more information about {pType} property in {areaReplace}, please <Link to="/contact-estate-agents-in-london/">contact</Link> our estate agents in London.</p>
          </div>
        </Container>
        <PropertyFilter type={this.props.ptype} 
                        department={this.props.pcategorytype}
                        sort_by={sort_by}/>
        <div className="d-none">
                        <SearchBox />
                        <CustomminpriceSelectbox attribute="price" type={this.props.ptype} />
                        <CustommaxpriceSelectbox attribute="price" type={this.props.ptype} />
                        <CustombuildingSelectbox attribute="building" type={this.props.ptype} department={this.props.pcategorytype} />
                        <CustombedroomSelectbox attribute="bedroom" />
                        {
                                        this.props.ptype === "sales" ?
                                        <CustomToggleRefinement
                                            attribute="status"
                                            label="Include Sold"
                                            value={['Sold Subject To Contract']}
                                            defaultRefinement={includeSold}
                                            includeSoldLet={includeSold}
                                        />
                                        :
                                        <CustomToggleRefinement
                                            attribute="status"
                                            label="Include Let"
                                            value={['Let Agreed']}
                                            defaultRefinement={includeLet}
                                            includeSoldLet={includeLet}
                                        />
                                    }
                                    <CustomSortByFilter
                                        defaultRefinement={index_name}
                                        className="search-sory-by"
                                        items={[
                                            { value: index_name+"_most_recent", label: "Most Recent" },
                                            { value: index_name, label: "Highest Price" },
                                            { value: index_name+"_price_asc", label: "Lowest Price" },
                                        ]}
                                    />
                                    
                    </div>
        {/* <PropertyCard /> */}
        <Container className='property-listing-container'>
        <CustomInfiniteHits 
                      location={this.props.fullpathname} 
                      tag={this.props.ptypetag}
                      userObjects={this.props.userObjects}
                    />

<CustomNoStats 
                      location={this.props.fullpathname} 
                      status={this.props.ptype} 
                      department={this.props.pcategorytype} 
                    />
                    </Container>
                    

                    
    </InstantSearch>
      </div>
    <Footer popularsearch={this.props.ptype == "sales" ? "Sales_Links" : "Rent_Links"}/>
    </>
  )
}
}

export default SearchResultsTemplate